export default __webpack_public_path__ + "media/choose-missions2x.1f4430bc.png";